import axios, { AxiosRequestConfig, Method } from 'axios';

// Handle HTTP request
export function handleRequest<T = any>(
  type: Method,
  url: string,
  data: Record<string, any> = {},
  customHeaders: Record<string, string> = {}
): Promise<T> {
  return new Promise((resolve, reject) => {
    const config: AxiosRequestConfig = {
      method: type,
      url: url,
      data: data,
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        ...customHeaders
      }
    };

    axios(config)
      .then(function (response) {
        let responseData: T = response.data;
        resolve(responseData);
      })
      .catch(function (error) {
        reject(error);
      });
  });
}
